// Dispatcher för per-block sidopanel-editorer.
// Returnerar rätt editor baserat på block.type. Editorn anropar onChange med ett
// partiellt patch — föräldern (emailBuilderModal) merger in det i blocks-staten.

import { Block } from '../types';
import { ButtonBlockEditor } from './ButtonBlockEditor';
import { DividerBlockEditor } from './DividerBlockEditor';
import { HeadingBlockEditor } from './HeadingBlockEditor';
import { ImageBlockEditor } from './ImageBlockEditor';
import { TextBlockEditor } from './TextBlockEditor';
import { TwoColumnsBlockEditor } from './TwoColumnsBlockEditor';

export { ButtonBlockEditor, DividerBlockEditor, HeadingBlockEditor, ImageBlockEditor, TextBlockEditor, TwoColumnsBlockEditor };

type Props = {
  block: Block;
  onChange: (patch: Partial<Block>) => void;
};

export const BlockEditor = ({ block, onChange }: Props) => {
  switch (block.type) {
    case 'heading':
      return <HeadingBlockEditor block={block} onChange={onChange as (p: Partial<typeof block>) => void} />;
    case 'text':
      return <TextBlockEditor />;
    case 'image':
      return <ImageBlockEditor block={block} onChange={onChange as (p: Partial<typeof block>) => void} />;
    case 'button':
      return <ButtonBlockEditor block={block} onChange={onChange as (p: Partial<typeof block>) => void} />;
    case 'divider':
      return <DividerBlockEditor block={block} onChange={onChange as (p: Partial<typeof block>) => void} />;
    case 'twoColumns':
      return <TwoColumnsBlockEditor />;
    default: {
      const exhaustive: never = block;
      throw new Error(`Okänd blocktyp i BlockEditor: ${JSON.stringify(exhaustive)}`);
    }
  }
};

// Returnerar en kort, översatt etikett för blocktypen — används i editor-headern.
export const blockTypeLabelKey = (type: Block['type']): string => `groupMessage:builder.palette.${type}`;
